import * as Yup from "yup";

const profissionalValidator = Yup.object().shape({
  profissao: Yup.string().required(),
  grupoPessoas: Yup.array().nullable(),
});

export default profissionalValidator;
